import React from "react";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Spinner
} from "reactstrap";
import moment from "moment";
import { GoogleMap } from "components/Map/GoogleMap";
import SweetAlert2 from "react-sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import Api from "shared/resources/Api";
import Header from "components/Headers/Header.js";
import ImageUploader from "react-images-upload";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { sectors, neighborhood } from "shared/services/PlacesService";
import InputMask from "react-input-mask";
import InputNumber from "react-input-just-numbers";
import gconf from "shared/resources/Gconf";
import DataTable from "react-data-table-component";

export default class StrategicPointEditar extends React.Component {
  columns = [
    {
      name: "Endereço",
      selector: "endereco",
      sortable: true,
    },
    {
      name: "Bairro",
      selector: "bairro",
      sortable: true,
      cell: (row) => <div>{row.bairro ? row.bairro : "-"}</div>,
    },
    {
      name: "Setor",
      selector: "setor",
      sortable: true,
      cell: (row) => <div>{row.setor ? row.setor : "-"}</div>,
    },
    {
      name: "Ação",
      cell: (row) => (
        <div>
          <Button
            type="button"
            className="btn-acao "
            title="Escolher"
            onClick={() => {
              this.handleSelectedAddress(row)
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="edit" />
            Escolher
          </Button>
        </div>
      ),
    },
  ];
  defaultComponentOptions = {
    rowsPerPageText: "Registros por Página:",
    rangeSeparatorText: "de",
    noRowsPerPage: false,
  };
  customStyles = {
    // cells: {
    //   style: {
    //     backgroundColor: "#F7FAFC"
    //   },
    // },
    table: {
      style: {
        backgroundColor: "#F7FAFC",
      },
    },
    headCells: {
      style: {
        fontWeight: 700,
        fontSize: 15,
        color: "#000",
        backgroundColor: "#F7FAFC"
      },
    },
  };
  constructor(props) {
    super(props);
    this.state = {
      cep: "",
      nome: "",
      descricao: "",
      logradouro: "",
      numero: "",
      bairro: "",
      setor: "",
      complemento: "",
      tel: "",
      lat: -18.90971,
      lon: -48.261921,
      api: Api.baseURL,
      isMapOk: false,
      isEdicao: false,
      foto: "",
      file: null,
      formTitle: "CADASTRAR",
      neighborhood: [],
      sectors: [],
      selectedSector: null,
      selectedNeighborhood: "",
      responseAddress: "",
      selectedAddress: "",
      photoIndex: 0,
      isOpen: false,
      lado: null,
      quarteirao: null,
      codigo: null
    };

    this.handleSave = this.handleSave.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  componentWillMount() {
    neighborhood().then((res) => {
      if (res) {
        this.setState({
          neighborhood: res,
        });
      }
    });
    if (
      this.props.location != null &&
      this.props.location.state != null &&
      this.props.location.state.property != null
    ) {
      this.setState(
        {
          strategicpoint: this.props.location.state.property,
          loading: false,
          nome: this.props.location.state.property.nome,
          lado: this.props.location.state.property.lado,
          tel: this.props.location.state.property.telefone,
          quarteirao: this.props.location.state.property.quarteirao,
          bairro: this.props.location.state.property.bairro,
          tipo: this.props.location.state.property.tipo,
          foto: this.props.location.state.property.media
            ? `${this.props.location.state.property.media.foto1}?${moment().format('YYYYMMDDHHMMSS')}`
            : "",
          descricao: this.props.location.state.property.descricao,
          logradouro: this.props.location.state.property.logradouro,
          selectedNeighborhood: this.props.location.state.property
            .bairro_setor
            ? this.props.location.state.property.bairro_setor.cod_bairro
            : "",
          numero: this.props.location.state.property.numero,
          complemento: this.props.location.state.property.complemento,
          selectedSector: this.props.location.state.property.setor,
          email: this.props.location.state.property.email,
          lat: this.props.location.state.property.lat,
          lon: this.props.location.state.property.lot,
          isMapOk: true,
          isEdicao: true,
          formTitle: "EDITAR",
          codigo: this.props.location.state.property.codigo
        },
        () => console.log("state logou end")
      );
    }
    sectors().then((res) => {
      if (res) {
        this.setState({
          sectors: res,
        });
      }
    });
  }

  fetchSectors = async () => {
    const response = await fetch(Api.baseURL + "/setor", {
      headers: {
        Authorization: localStorage.getItem("agToken"),
      },
    });
    const body = await response.json();

    if (response.status === 200) {
      this.setState({
        sectors: body,
      });
    }

    return body;
  };

  handleSelectedAddress = (row) => {
    console.log(row, 'escolheu')
    this.setState({ selectedAddress: row, logradouro: row.endereco, bairro: row.bairro, setor: row.setor });
  };


  handleSiat = (event) => {

    if (
      this.state.logradouro === undefined ||
      this.state.logradouro.length === 0
    ) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Logradouro.",
          type: "warning",
        },
      });

      return false;
    } else {
      if (this.state.selectedAddress === "") {
        this.setState({ requesting: true });

        this.fetchSiat()
          .then((res) => this.setState({ responseAddress: res }))
          .catch((err) => {
            console.log(err);
            this.setState({
              swal: {
                show: true,
                title: "Atenção",
                text:
                  "Não foram encontrados endereços para os parâmetros informados.",
                type: "error",
              },
              requesting: false,
            });
          });
      } else {
        this.setState({ selectedAddress: "", logradouro: "", bairro: "", responseAddress: "" });
      }
    }




    event.preventDefault();
  };

  fetchSiat = async () => {
    let host = this.state.api + "/siat_enderecos?";

    let params = {
      endereco: this.state.logradouro,
      bairro: this.state.bairro ? this.state.bairro : ""
    };

    let esc = encodeURIComponent;
    let query = Object.keys(params)
      .map((k) => esc(k) + "=" + esc(params[k]))
      .join("&");

    const response = await fetch(host + query, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });

    const body = await response.json();

    if (body.length > 0) {
      this.setState({
        requesting: false,
      });
    } else {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text:
            "Não foram encontrados endereços para os parâmetros informados.",
          type: "error",
        },
        requesting: false,
      });
    }
    return body;
  };



  handleSave(event) {
    if (this.validateFields()) {
      this.callSave();
    }
  }

  blurEndereco = () => {
    this.consultarLatLong();
  };

  consultarLatLong = () => {
    this.setState({ isMapOk: false });
    const addres = `${this.state.logradouro}, ${this.state.numero}, ${this.state.bairro}, ${this.state.cep},uberlandia`;
    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${addres}&components=country:BR|administrative_area:MG|locality:Uberlandia&key=${gconf.key}`
    )
      .then((response) => response.json())
      .then((res) => {
        if (res && res.status === "OK") {
          console.log(res);
          if (
            res.results.length > 0 &&
            res.results[0].geometry &&
            res.results[0].geometry.location
          ) {
            this.setState({
              ...this.state,
              lat: res.results[0].geometry.location.lat,
              lon: res.results[0].geometry.location.lng,
              isMapOk: true,
            });
          }
        }
      })
      .catch((err) => {
        this.setState({
          ...this.state,
          lat: -18.90971,
          lon: -48.261921,
          isMapOk: true,
        });
      });
  };

  onDrop(pictureFiles, pictureDataURLs) {
    this.setState(
      {
        foto: pictureDataURLs[pictureDataURLs.length - 1],
        pictures: [],
        file: pictureFiles[pictureFiles.length - 1],
      },
      () => console.log(this.state.feed)
    );
  }

  validateFields() {
    /* Validação obrigatoriedade */

    if (
      this.state.codigo === undefined ||
      this.state.codigo === null ||
      this.state.codigo.length === 0
    ) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Código.",
          type: "warning",
        },
      });

      return false;
    } else {
      if (this.state.codigo === "0") {
        this.setState({
          swal: {
            show: true,
            title: "Atenção",
            text: "Código não pode ser igual a zero.",
            type: "warning",
          },
        });

        return false;
      }
    }
    if (this.state.nome === undefined || this.state.nome.length === 0) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Nome do Proprietário",
          type: "warning",
        },
      });

      return false;
    }
    if (
      this.state.tel === undefined ||
      this.state.tel.replace(/\D/g, "").length === 0
    ) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Telefone.",
          type: "warning",
        },
      });

      return false;
    }


    if (
      this.state.logradouro === undefined ||
      this.state.logradouro.length === 0
    ) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Endereço.",
          type: "warning",
        },
      });

      return false;
    }
    if (this.state.numero === undefined || this.state.numero.length === 0) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Número.",
          type: "warning",
        },
      });

      return false;
    }
    if (
      this.state.bairro === undefined ||
      this.state.bairro === "" ||
      this.state.bairro === null
    ) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Bairro.",
          type: "warning",
        },
      });

      return false;
    }

    if (
      this.state.tel !== "" &&
      this.state.tel.replace(/\D/g, "").length !== 11 &&
      this.state.tel.replace(/\D/g, "").length !== 10
    ) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Preencha o telefone com DDD e nono Dígito caso haja.",
          type: "warning",
        },
      });

      return false;
    }
    /* Validação integridade */

    return true;
  }

  createBody = () => {
    if (this.state.strategicpoint) {
      return JSON.stringify({
        nome:
          this.state.nome !== ""
            ? this.state.nome
            : this.state.strategicpoint.nome,
        descricao: this.state.descricao,
        tel:
          this.state.tel !== ""
            ? this.state.tel.replace(/\D/g, "")
            : this.state.tireshop.tel.replace(/\D/g, ""),
        bairro:
          this.state.bairro !== ""
            ? this.state.bairro
            : "",
        lado: this.state.lado,
        quarteirao: this.state.quarteirao !== null && this.state.quarteirao !== undefined ? this.state.quarteirao : 0,
        logradouro: this.state.logradouro.trim(),
        numero: this.state.numero,
        setor:
          this.state.selectedSector !== ""
            ? this.state.selectedSector
            : "",
        complemento: this.state.complemento,

        geolocalizacao: {
          lat: (this.state.lat !== ""
            ? this.state.lat
            : this.state.strategicpoint.lat
          ).toString(),
          lon: (this.state.lon !== ""
            ? this.state.lon
            : this.state.strategicpoint.lon
          ).toString(),
        },
        codigo: this.state.codigo
      });
    } else {
      return JSON.stringify({
        nome: this.state.nome,
        descricao: this.state.descricao,
        tel: this.state.tel.replace(/\D/g, ""),
        setor:
          this.state.selectedSector !== ""
            ? this.state.selectedSector
            : "",
        bairro:
          this.state.bairro !== ""
            ? this.state.bairro
            : "",
        lado: this.state.lado,
        quarteirao: this.state.quarteirao !== null && this.state.quarteirao !== undefined ? this.state.quarteirao : 0,
        logradouro: this.state.logradouro.trim(),
        numero: this.state.numero,
        complemento: this.state.complemento,
        geolocalizacao: {
          lat: this.state.lat.toString(),
          lon: this.state.lon.toString(),
        },
        codigo: this.state.codigo
      });
    }
  };

  callSave = async () => {
    var data = new FormData();
    data.append("ponto_estrategico", this.createBody());

    if (this.state.file !== null) {
      data.append("foto1", this.state.file);
    }
    const response = await fetch(
      Api.baseURL +
      "/ponto_estrategico/" +
      (this.state.strategicpoint ? this.state.strategicpoint.id : ""),
      {
        method: this.state.strategicpoint ? "PUT" : "POST",
        headers: {
          Accept: "application/json",
          Authorization: localStorage.getItem("agToken"),
        },
        body: data,
      }
    );
    const body = await response.json();

    if (response.status === 200 && body.sucesso === true) {
      this.setState({
        swal: {
          show: true,
          title: "Tudo Certo",
          text: this.state.strategicpoint
            ? "Edição realizada com sucesso!"
            : "Cadastro realizado com sucesso!",
          type: "success",
        },
        isSuccess: true,
      });
    } else if (body.sucesso === false) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: body.msg,
          type: "warning",
        },
      });
      console.log(body.erro);
    } else {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: this.state.strategicpoint
            ? "Erro ao editar ponto estratégico. "
            : "Erro ao cadastrar ponto estratégico.",
          type: "warning",
        },
      });
      console.log(body.erro);
    }

    return body;
  };
  render() {
    return (
      <>
        <SweetAlert2
          {...this.state.swal}
          onConfirm={(result) => {
            this.setState({
              swal: {
                show: false,
              },
            });
            if (this.state.isSuccess) {
              this.props.history.push(`/admin/cadastroListar`);
            }
          }}
        />
        {this.state.isOpen && (
          <Lightbox
            mainSrc={this.state.foto}
            onCloseRequest={() => this.setState({ isOpen: false })}
          />
        )}
        <Header />
        {/* Page content */}
        <Container className="mb-7 mt-5 " fluid>
          <Row className="mb-3">
            <Col className="order-xl-1">
              <Card className="bg-secondary shadow">
                <CardBody>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">
                      {this.state.formTitle} Ponto Estratégico{" "}
                    </h6>
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="2">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-comp"
                            >
                              Código *
                            </label>

                            <InputNumber
                              onlydigits
                              className="form-control"
                              id="input-codigo"
                              inputMode="numeric"
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value)
                                )
                                  .toString()
                                  .slice(0, 6);
                              }}
                              placeholder=""
                              value={this.state.codigo}
                              onChange={(e) =>
                                this.setState({ codigo: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="7">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                              Nome Proprietário *
                            </label>

                            <Input
                              className="form-control-alternative"
                              id="input-nome"
                              type="text"
                              required
                              value={this.state.nome}
                              onChange={(e) =>
                                this.setState({ nome: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-first-name"
                            >
                              Telefone *
                            </label>
                            <InputMask
                              mask="(99) 99999-9999"
                              type="text"
                              name="tel"
                              id="tel"
                              inputMode="numeric"
                              className="form-control"
                              value={this.state.tel}
                              onChange={(e) =>
                                this.setState({ tel: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>


                      <Row>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-address"
                            >
                              Logradouro *
                                </label>
                            <Input
                              className="form-control-alternative"
                              id="input-address"
                              disabled={this.state.selectedAddress !== ""}
                              placeholder=""
                              type="text"
                              value={this.state.logradouro}
                              onChange={(e) =>
                                this.setState({
                                  logradouro: e.target.value,
                                })
                              }
                              onBlur={this.blurEndereco}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-bairro"
                            >
                              Localidade *
                            </label>

                            <Input
                              className="form-control-alternative"
                              id="input-lado"
                              type="text"
                              maxLength="40"
                              disabled={this.state.selectedAddress !== ""}
                              value={this.state.bairro}
                              onChange={(e) =>
                                this.setState({ bairro: e.target.value })
                              }
                              onBlur={this.blurEndereco}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            {this.state.sectors.length > 0 && (
                              <div>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-last-dtnascimento"
                                >
                                  Região
                                </label>

                                <select
                                  value={this.state.selectedSector}
                                  onChange={(e) =>
                                    this.setState({
                                      selectedSector: e.target.value,
                                    })
                                  }
                                  className="form-control "
                                >
                                  <option defaultValue="" value="">
                                    {" "}
                                    Selecione...{" "}
                                  </option>
                                  {this.state.sectors.map((team) => (
                                    <option
                                      key={team.id}
                                      value={team.nome}
                                      defaultValue={this.state.selectedSector}
                                    >
                                      {team.nome}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}
                          </FormGroup>
                        </Col>

                        <Col lg="2">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-city"
                            >
                              Número *
                                </label>
                            <Input
                              className="form-control-alternative"
                              id="input-number"
                              placeholder=""
                              type="text"
                              value={this.state.numero}
                              onChange={(e) =>
                                this.setState({ numero: e.target.value })
                              }
                              onBlur={this.blurEndereco}
                            />
                          </FormGroup>
                        </Col>


                      </Row>

                      <Row>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-complement"
                            >
                              Complemento
                                </label>
                            <Input
                              className="form-control-alternative"
                              id="input-complement"
                              placeholder=""
                              type="text"
                              maxLength={20}
                              value={this.state.complemento}
                              onChange={(e) =>
                                this.setState({
                                  complemento: e.target.value,
                                })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-comp"
                            >
                              Quarteirão
                            </label>

                            <InputNumber
                              onlydigits
                              className="form-control"
                              id="input-quarteirao"
                              inputMode="numeric"
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value)
                                )
                                  .toString()
                                  .slice(0, 4);
                              }}
                              placeholder=""
                              value={this.state.quarteirao}
                              onChange={(e) =>
                                this.setState({ quarteirao: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-comp"
                            >
                              Lado
                            </label>

                            <Input
                              className="form-control-alternative"
                              id="input-comp"
                              type="text"
                              required
                              maxLength={4}
                              value={this.state.lado}
                              onChange={(e) =>
                                this.setState({ lado: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <div className="text-left mt-4 pt-2">
                              <Button
                                className={this.state.selectedAddress === "" ? "btn-zoo-alt" : "btn-zoo"}
                                color="primary"
                                type="button"
                                onClick={this.handleSiat}
                              >
                                {this.state.selectedAddress === "" ? "Consultar Endereço" : "Alterar Endereço"}

                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>


                      {this.state.responseAddress && !this.state.requesting && this.state.selectedAddress === "" && (
                        <DataTable
                          noHeader={true}
                          pagination={true}
                          striped={true}
                          columns={this.columns}
                          sortable={true}
                          responsive={true}
                          highlightOnHover={true}
                          data={this.state.responseAddress}
                          noDataComponent="Nenhum registro encontrado."
                          paginationComponentOptions={this.defaultComponentOptions}
                          customStyles={this.customStyles}
                        />
                      )}

                      {this.state.requesting && (
                        <div className="text-center">
                          <Spinner
                            style={{ width: "3rem", height: "3rem" }}
                            color="primary"
                          />

                        </div>

                      )}
                      <Row>
                        <Col lg="12">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-last-dtnascimento"
                            >
                              Descrição
                            </label>
                            <Input
                              id="input-conteudo"
                              maxLength={1000}
                              value={this.state.descricao}
                              onChange={(e) =>
                                this.setState({
                                  descricao: e.target.value,
                                })
                              }
                              rows="3"
                              type="textarea"
                              className="form-control-alternative"
                            />
                          </FormGroup>
                        </Col>
                      </Row>




                      <Row>
                        <Col lg="12">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                              Foto
                            </label>
                            <ImageUploader
                              withIcon={false}
                              withLabel={false}
                              buttonText=""
                              onChange={this.onDrop}
                              imgExtension={[
                                ".jpg",
                                ".gif",
                                ".png",
                                ".gif",
                                ".jpeg",
                              ]}
                              fileSizeError=" O arquivo deve ter até 5mb"
                              fileTypeError=" Extensão do arquivo não suportada"
                              maxFileSize={5242880}
                              buttonClassName={"zoo-feed-photo"}
                            />{" "}
                          </FormGroup>
                        </Col>
                      </Row>
                      {this.state.foto !== "" && (
                        <Row className="text-center">
                          <Col lg="12">
                            <FormGroup>
                              {this.state.foto !== "" && (
                                <img
                                  style={{ cursor: "pointer" }}
                                  className="img-fluid"
                                  src={this.state.foto}
                                  alt="Imagem Imóvel"
                                  onClick={() =>
                                    this.setState({ isOpen: true })
                                  }
                                />
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      )}
                    </div>
                    {this.state.isMapOk && (
                      <Row>
                        <Col lg="12" style={{ height: "40vh", paddingLeft: 0 }}>
                          <GoogleMap
                            lat={this.state.lat}
                            lng={this.state.lon}
                          />
                        </Col>
                      </Row>
                    )}
                    {localStorage.getItem("perm") !== "agente" && (
                      <div className="text-center">
                        <Row>
                          <Col className="order-xl-1" xl="12">
                            <Button
                              className="mt-4 btn-zoo"
                              color="primary"
                              type="button"
                              onClick={this.handleSave}
                            >
                              <b>
                                {this.state.isEdicao
                                  ? "Salvar Alterações"
                                  : "Cadastrar"}
                              </b>
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    )}
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}
